import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SendByIdPayload,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { ArticlePayload } from '../models/article-payload';

export const ArticleEditActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[article] Edit'),
  requestFail: uniqueActionType('[article] Edit fail'),
  requestSuccess: uniqueActionType('[article] Edit success'),
  requestClearErrors: uniqueActionType('[article] Edit clear errors'),
  requestClear: uniqueActionType('[article] Edit clear')
};

export class ArticleEditAction implements PayloadAction {
  readonly type = ArticleEditActionTypes.request;

  constructor(public payload: SendByIdPayload<ArticlePayload>) {
  }
}

export class ArticleEditFailAction implements PayloadAction {
  readonly type = ArticleEditActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class ArticleEditSuccessAction implements PayloadAction {
  readonly type = ArticleEditActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class ArticleEditClearErrorsAction implements PayloadAction {
  readonly type = ArticleEditActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class ArticleEditClearAction implements PayloadAction {
  readonly type = ArticleEditActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
